import { render, staticRenderFns } from "./ScheduleScreen.vue?vue&type=template&id=fde0fb0c"
import script from "./ScheduleScreen.vue?vue&type=script&lang=js"
export * from "./ScheduleScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports